<template>
  <article>
    <router-view></router-view>
  </article>
</template>

<script>
import { mapActions } from "vuex"

export default {
  name: "app",
  components: {},
  data() {
    return {}
  },
  created() {
    window.addEventListener("resize", this.windowResizeListener)
  },
  mounted() {
    this.windowResizeListener(this)
  },
  methods: {
    ...mapActions(["setSmallDevice"]),
    windowResizeListener(e) {
      let windowWidth = e.target ? e.target.innerWidth : e.$el.offsetWidth
      this.setSmallDevice(windowWidth < 1024)
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResizeListener)
  },
}
</script>

<style></style>
